import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "reactstrap";
import PrivacyPolicyComponent from "../../components/PrivacyPolicyComponent"

// hooks
import { useRedux } from "../../hooks/index";

// components
import NonAuthLayoutWrapper from "../../components/NonAutnLayoutWrapper";
import withRouter from "../../components/withRouter";


const PrivacyPolicy = (props: any) => {
  const navigate = useNavigate();

  return (
    <NonAuthLayoutWrapper>
      <Row className="justify-content-center my-auto">
        <Col>
          <PrivacyPolicyComponent />
        </Col>
      </Row>
    </NonAuthLayoutWrapper>
  );
};

export default withRouter(PrivacyPolicy);
